import { i18n } from 'i18n';

export const TRAFFICS: { [key: string]: string } = {
	youtube: i18n.t('YouTube'),
	snapchat: i18n.t('Snapchat'),
	facebook_ads: i18n.t('Facebook Ads (Facebook/ Instagram)'),
	in_app: i18n.t('In-app'),
	google_ads_uac: i18n.t('Google Ads UAC'),
	asa: i18n.t('ASA'),
	tiktok_ads: i18n.t('TikTok Ads'),
	incentive_traffic: i18n.t('Incentive traffic'),
	adult: i18n.t('Adult'),
	mobile_web: i18n.t('Mobile Web'),
};
